module.exports = __webpack_public_path__ + "img/1.2add5c41.png";